export default __webpack_public_path__ + "static/media/popularity.bd5a70ed.jpg";